<template>
    <el-dialog
        title="添加调研"
        :visible.sync="visible"
        width="7.7rem"
        class="step-audit-dialog"
        key="research"
        :before-close="handleResearchDialogClose">
        <el-form :model="form" :inline="true" label-width="100px" key="6" class="user-step-search-form">
            <el-form-item label="问卷名称：" prop="title">
                <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="" class="search-item-long-btn">
                <el-button size="mini" @click="handleResearchDialogSearch">查询</el-button>
                <el-button size="mini" class="reset-btn" @click="handleResearchDialogReset">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="training-step-table">
            <el-table :data="tableForm.formResult.list" style="width: 100%" key="researchtable" @selection-change="handleResearchTableSeleChange">
                <el-table-column type="selection"></el-table-column>
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="title" label="问卷名称"></el-table-column>
                <el-table-column prop="orgName" label="归属机构"></el-table-column>
                <el-table-column prop="updateTime" label="发布时间" width="168"></el-table-column>
                <el-table-column prop="username" label="发布人账号"></el-table-column>
                <el-table-column prop="status" label="发布状态">
                    <template slot-scope="scope">
                        <span>{{statusObj[scope.row.status]}}</span>
                    </template>
                </el-table-column>
            </el-table>                
        </div>
        <div class="dialog-footer">
            <el-button type="primary" size="mini" @click="handleResearchDialogSave">保存</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'queDialog',
    props: ['visible'],
    data() {
        return {
            form: {title: ''},
            tableForm: {
                formResult: { currentPage: 1, list: [], total: 0 },
                pageData: { currentPage: 1, pageSize: 10, sortName: '', sortOrder: '' }
            },
            selectTable: [],
            statusObj: {0: '未发布', 1: '未开始', 2: '进行中', 3: '已结束' }
        }
    },
    methods: {
        // 弹窗-调研搜索
        handleResearchDialogSearch() {
            this.tableForm.pageData.currentPage = 1
            this.querySurveyList()
        },
        // 弹窗-表格选择
        handleResearchTableSeleChange(data) {
            this.selectTable = data
        },
        // 弹窗-调研重置
        handleResearchDialogReset() {
            this.form.title = ''
            this.handleResearchDialogSearch()
        },
        // 弹窗-调研保存
        handleResearchDialogSave() {
            this.$emit('confirmDailog', this.selectTable)
            this.handleResearchDialogClose()
        },
        // 弹窗-调研关闭
        handleResearchDialogClose() {
            this.$emit('closeDailog')
        },
        // 加载调研
        querySurveyList() {
            this.$api.course.surveyList({
                formData: { title: this.form.title },
                pageData: this.tableForm.pageData
            }).then(res => {
                this.tableForm.formResult = res.data
            })
        },
    },
    watch: {
        visible(val) {
            if (val) {
                this.selectTable = null
                this.handleResearchDialogReset()
            }
        }
    }
}
</script>